import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PublicOnlyRoute() {
  const { token, isAuthChecked } = useSelector((state) => state.auth);

  if (!isAuthChecked) {
    return null;
  }

  if (token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
